import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { bonusValueRows } from '../data/bonuses';
import { bonusValue, brandName, fullPrice, included, volumesValue } from '../data/copy';
export function OfferSection() {
  return <section id="oferta" className="defer-paint w-full scroll-mt-6 bg-zinc-950 py-12 sm:py-16" aria-labelledby="offer-heading" data-id="element-117" data-mp="df6ti6u4n1iv">
      <div className="mx-auto max-w-5xl px-6" data-id="element-118" data-mp="icylt1yoopnl">
        <div className="mx-auto max-w-2xl text-center" data-id="element-119" data-mp="meadre515myy">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-120" data-mp="md0fooy6gesb">Il tuo accesso completo oggi</p>
          <h2 id="offer-heading" className="mt-4 font-serif text-[2rem] font-bold leading-[1.1] text-stone-100 sm:text-4xl" data-id="element-121" data-mp="wcr7givcsfop">
            {brandName}
          </h2>
          <p className="mt-3 font-sans text-base leading-relaxed text-stone-400" data-id="element-122" data-mp="2t7dx2mtcbw0e">
            Sistema completo: 6 volumi + 96 sessioni + 5 bonus.
          </p>
        </div>

        <div className="mt-9 grid gap-6 lg:grid-cols-[1fr_1.1fr] lg:gap-8" data-id="element-123" data-mp="12oa80txae5ip">
          {/* En móvil el contador y la tarjeta de precio van primero, para que
              el CTA del hero aterrice directamente sobre la oferta. */}
          <div className="contents lg:flex lg:flex-col lg:gap-6" data-id="element-124" data-mp="svm9nuqnrthv">
            <div className="order-1 lg:order-none" data-id="element-125" data-mp="oxetb103wu77">
              <CountdownTimer data-id="element-126" data-mp="1lm4dixz7hywc" />
            </div>

            <div className="order-3 rounded-3xl border border-zinc-800 bg-zinc-900 p-6 sm:p-7 lg:order-none" data-id="element-127" data-mp="1llull4ulpho0">
              <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-stone-400" data-id="element-128" data-mp="1go2u2bxvbxkc">Quanto vale separatamente</p>
              <ul className="mt-5 divide-y divide-zinc-800" data-id="element-129" data-mp="17mv9ewo9yv8q">
                <li className="flex items-baseline justify-between gap-4 py-2.5 font-sans text-[0.85rem] text-stone-200" data-id="element-130" data-mp="17mbs9i6g8avr">
                  <span data-id="element-131" data-mp="146jjqpw7omw">6 volumi tecnici — 96 sessioni</span>
                  <span className="shrink-0 text-stone-400" data-id="element-132" data-mp="3sb97m9afpesw">{volumesValue}</span>
                </li>
                {bonusValueRows.map(row => <li key={row.label} className="flex items-baseline justify-between gap-4 py-2.5 font-sans text-[0.85rem] text-stone-200" data-id="element-133" data-mp="3trwvv76appb1">
                    <span data-id="element-134" data-mp="3ku2xlqoz0ll8">{row.label}</span>
                    <span className="shrink-0 text-stone-400" data-id="element-135" data-mp="3kt1ohrrim965">{row.value}</span>
                  </li>)}
              </ul>
              <div className="mt-4 flex items-baseline justify-between gap-4 border-t border-yellow-500/30 pt-4" data-id="element-136" data-mp="3owr9k78ze8mf">
                <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-yellow-500" data-id="element-137" data-mp="3ftygpzk5houh">
                  Valore totale del sistema
                </span>
                <span className="font-serif text-3xl font-bold leading-none text-yellow-500" data-id="element-138" data-mp="313hg2ifcb2yn">
                  {fullPrice}
                </span>
              </div>
              <p className="mt-4 font-sans text-[0.82rem] leading-relaxed text-stone-400" data-id="element-139" data-mp="2s55tcrhlgpbh">
                I 5 bonus ({bonusValue}) sono inclusi oggi senza costi
                aggiuntivi.
              </p>
            </div>
          </div>

          <div className="order-2 rounded-3xl border border-yellow-500/40 bg-zinc-900 p-6 text-center shadow-2xl shadow-black/60 sm:p-9 lg:order-none" data-id="element-140" data-mp="28iu6vohpphj3">
            <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-141" data-mp="2mjes0rb3npfr">
              Offerta di lancio
            </p>
            <p className="mt-3 font-sans text-sm text-stone-400" data-id="element-142" data-mp="2wgje6r4y3kwk">
              Valore normale:{' '}
              <span className="line-through" data-id="element-143" data-mp="2rhzsmru9kb4q">{fullPrice}</span>
            </p>
            <p className="mt-2 flex items-start justify-center gap-1 font-serif font-bold leading-none text-stone-100" data-id="element-144" data-mp="2rfvl7zx5otzp">
              <span className="mt-3 text-2xl text-yellow-500" data-id="element-145" data-mp="316zqg7x150hc">€</span>
              <span className="text-[5rem] leading-none sm:text-[6rem]" data-id="element-146" data-mp="319vodw8vnp5s">19</span>
            </p>
            <p className="mt-2 font-sans text-xs uppercase tracking-[0.16em] text-stone-400" data-id="element-147" data-mp="3f57ros13mnyb">
              Un solo pagamento · nella tua valuta locale
            </p>

            <p className="mt-6 text-left font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-yellow-500" data-id="element-148" data-mp="18i8rhbt3uxzd">
              Cosa riceverai
            </p>

            <ul className="mt-3 grid grid-cols-1 gap-x-4 gap-y-2 border-t border-zinc-800 pt-4 text-left sm:grid-cols-2 sm:gap-x-6" data-id="element-149" data-mp="1i8bnzlzfqu2g">
              {included.map(item => <li key={item} className="flex items-start gap-2 font-sans text-[0.8rem] leading-snug text-stone-200 sm:text-[0.86rem]" data-id="element-150" data-mp="1mcjadcif7xxi">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-yellow-500" strokeWidth={2.6} aria-hidden="true" data-id="element-151" data-mp="uir2avbwdiph" />
                  {item}
                </li>)}
            </ul>

            <CtaButton size="large" className="mt-7 w-full" data-id="element-152" data-mp="13jp7hgy2nw9n">
              Accesso completo ora
            </CtaButton>

            <p className="mt-4 text-center font-sans text-[11px] text-stone-400" data-id="element-153" data-mp="2a0stg6o927ky">
              Pagamento sicuro · accesso immediato · garanzia di 7 giorni
            </p>
          </div>
        </div>
      </div>
    </section>;
}